import { XCircle } from "lucide-react";

import type { IconWrapperProps } from "./icon-wrapper";
import { IconWrapper } from "./icon-wrapper";

export function IconXCircle(props: IconWrapperProps) {
  return (
    <IconWrapper {...props}>
      <XCircle />
    </IconWrapper>
  );
}
